export default __webpack_public_path__ + "static/media/check.2dda296a.png";